import React from "react"
import img from '../../assets/images/ig.svg';

function Instagram() {
    // Import result is the URL of your image
    return <img className="c4_image" alt="For Crew Only"  src={img} />
}
export default Instagram
